import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { LoadScriptNext } from "@react-google-maps/api";
import { Hub } from "aws-amplify";
import { AuthProvider, AppBootScreen } from "auth";
import { StoreProvider } from "context";
import { Toast } from "@/ui";
import { ApolloProviderWrapper } from "./apollo/components";
import { PendoInitializer } from "./base/components/pendoinitializer";
import Layout from "./base/layout/Layout";
import { containerSettings } from "./config/components/toast";

// Create a client
const queryClient = new QueryClient();

const App = () => {
    const googleMapKey = process?.env?.REACT_APP_GOOGLE_MAP_API_KEY;
    useEffect(() => {
        const listener = data => {
            const { event } = data.payload;
            // we are doing this to make sure the store menu does
            // not get cached with the previuos selected sotre
            // when changing the login between the stores.
            if (event === "signIn") {
                window.location.reload();
            }
        };

        Hub.listen("auth", listener);

        return () => Hub.remove("auth", listener);
    }, []);

    return (
        <QueryClientProvider client={queryClient}>
            <BrowserRouter>
                <section className="auth_container">
                    <AuthProvider>
                        <ApolloProviderWrapper>
                            <StoreProvider>
                                <PendoInitializer />
                                <LoadScriptNext
                                    googleMapsApiKey={googleMapKey}
                                    loadingElement={<AppBootScreen />}
                                >
                                    <Layout />
                                </LoadScriptNext>
                            </StoreProvider>
                            <Toast {...containerSettings} stacked />
                        </ApolloProviderWrapper>
                    </AuthProvider>
                </section>
            </BrowserRouter>
            <ReactQueryDevtools
                buttonPosition="bottom-left"
                initialIsOpen={false}
            />
        </QueryClientProvider>
    );
};

export default App;
